const devConfig = {
  isMock: false,
  defaultMockDelay: 100,
  serverIP: 'http://103.91.191.229:9000',
  // serverIP: 'https://egranting-uat.thaihealth.or.th:9001',
  defaultLoginUrl: process.env.REACT_APP_LOGIN_URL,
  defaultLogoutUrl: process.env.REACT_APP_LOGOUT_URL,
}

const prodConfig = {
  serverIP: process.env.REACT_APP_API_URL,
  defaultLoginUrl: process.env.REACT_APP_LOGIN_URL,
  defaultLogoutUrl: process.env.REACT_APP_LOGOUT_URL,
}

export const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig

export const API_ROOT = `${config.serverIP}/api`

//API call timeout [unit milliseconds] default 5 minute
export const TIMEOUT = 300000
export const API_TIMEOUT = { timeout: TIMEOUT }
